import { type EducationRecordProps } from './components/EducationRecord';

export const educationRecords: EducationRecordProps[] = [
  {
    degree: 'Bachelor of Science in Computer Science',
    institution: 'Syracuse University',
    year: '2024',
  },
  {
    degree: 'IT, Networking, and Cybersecurity Diploma',
    institution: 'SUNY Adirondack',
    year: '2020',
  },
];
